import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik} from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import TablePagination from '@material-ui/core/TablePagination';
import { LoadingComponent } from '../../../../utils/newLoader';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
  

}));

const screenCode = 'EMPLOYEEATTENDANCEDETAILSREPORT';

export default function EmployeeAttendanceDetailsReport(props) {
  const [title, setTitle] = useState("Employee Attendance Details Report");
  const classes = useStyles();
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [attendanceDetail, setAttendanceDetail] = useState({
    groupID: 0,
    factoryID: 0,
    registrationNumber: '',
    date: new Date().toISOString().substring(0, 10),
    employeeTypeID: 0
  });
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [attendanceData, setAttendanceData] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    employeeTypeName: "0"
  })

  const navigate = useNavigate();
  const alert = useAlert();
  const [csvHeaders, SetCsvHeaders] = useState([])
  const componentRef = useRef();

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown()
    );
    trackPromise(
      getEmployeeTypesForDropdown()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [attendanceDetail.groupID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'EMPLOYEEATTENDANCEDETAILSREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setAttendanceDetail({
      ...attendanceDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(attendanceDetail.groupID);
    setFactoryList(factories);
  }

  async function getEmployeeTypesForDropdown() {
      const result = await services.GetEmployeeTypesData();
      setEmployeeTypes(result);
    }

  async function GetDetails() {
    let model = {
      groupID: attendanceDetail.groupID,
      factoryID: attendanceDetail.factoryID,
      date: attendanceDetail.date,
      registrationNumber: attendanceDetail.registrationNumber,
      employeeTypeID: attendanceDetail.employeeTypeID
    };
     getSelectedDropdownValuesForReport(attendanceDetail.groupID, attendanceDetail.factoryID, attendanceDetail.employeeTypeID);
    const employeeAttendanceData = await services.GetEmployeeAttendanceDetails(model);
    if (employeeAttendanceData.statusCode == "Success" && employeeAttendanceData.data != null) {
       setAttendanceData(employeeAttendanceData.data);
       createDataForExcel(employeeAttendanceData.data);
      if (employeeAttendanceData.data.length == 0) {
        alert.error("No records to display");
      }
    } 
  }

  async function createDataForExcel(array) {
  var res = [];

  if (array != null) {
      const totalRecords = array.length;
      array.map(x => {
          var vr = {
              'Reg No': x.registrationNumber,
              'Employee Code': x.employeeCode,
              'Employee Name': x.employeeName,
              'Employee Type':x.employeeTypeName,
              'In Time': x.inTime ? formatDateTimeForExcel(x.inTime) : "N/A",
              'Out Time': x.outTime ? (formatDateTimeForExcel(x.outTime)) : "Pending...",
              'OT Hours': x.otHours + "m",
              'Regular Hours': calculateRegularHours(x.inTime, x.outTime, x.otHours),
              'Total Hours': formatDecimalHours(x.totalHours)
          }
          res.push(vr);
      });
      res.push({})

      var vr = {
          'Reg No': 'Group: ' + selectedSearchValues.groupName,
          'Employee Code': 'Factory: ' + selectedSearchValues.factoryName
      }
      res.push(vr);

      var vr = {
          'Reg No': attendanceDetail.registrationNumber === '' ? 'All Employees' : 'Reg No: ' + attendanceDetail.registrationNumber,
          'Employee Code': 'Date: ' + attendanceDetail.date,
          'Employee Name':attendanceDetail.employeeTypeID == 0 ? 'Employee Type: All' : 'Employee Type: ' + selectedSearchValues.employeeTypeName 
      }
      res.push(vr);

        var vr = {
          'Reg No': 'Total Records: ' +totalRecords,
          
      }
      res.push(vr);
  }
  return res;
}

  async function createFile() {
    var file = await createDataForExcel(attendanceData);
    var settings = {
      sheetName: 'Employee Attendance Report',
      fileName: 'Employee Attendance Details Report - ' + selectedSearchValues.groupName + ' ' + selectedSearchValues.factoryName + ' ' + attendanceDetail.date,
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: '',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }

  function getSelectedDropdownValuesForReport(groupID, factoryID, employeeTypeID) {
  setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[groupID],
      factoryName: FactoryList[factoryID],
      employeeTypeName: employeeTypes[employeeTypeID] 
  })
}

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

function calculateRegularHours(inTime, outTime, otHours) {
  const inDate = new Date(inTime);
  const outDate = new Date(outTime);
  let totalMinutes = (outDate - inDate) / (1000 * 60);
  let regularMinutes = Math.max(0, totalMinutes - (otHours || 0))
  const maxMinutes = 9 * 60; 
  regularMinutes = Math.min(regularMinutes, maxMinutes);
  const hours = Math.floor(regularMinutes / 60);
  const minutes = Math.floor(regularMinutes % 60);
  return `${hours}h ${minutes}m`;
}

function formatDateTimeForExcel(dateTime) {  
  const dateTtime = new Date(dateTime);
  const date = dateTtime.toLocaleDateString('en-CA'); 
  const time = dateTtime.toLocaleTimeString('en-GB', { 
    hour: '2-digit', 
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
  
  return `${date}/${time}`; 
}

function handleDateTime(dateTime) {
  const dateTtime = new Date(dateTime);
  const date = dateTtime.toLocaleDateString('en-CA');
  const time = dateTtime.toLocaleTimeString('en-GB', { 
    hour: '2-digit', 
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
  return (
    <>
      {date}
      <br />
      <strong>{time}</strong>
    </>
  );
}

function formatDecimalHours(decimalHours) {
  const hours = Math.floor(decimalHours);
  const minutes = Math.floor((decimalHours - hours) * 60);
  return `${hours}h ${minutes}m`;
}

  function handleChange(e) {
  const target = e.target;
  const value = target.value;
  if (target.name === 'groupID') {
    setAttendanceDetail({
      ...attendanceDetail,
      [e.target.name]: value,
      factoryID: 0,
    });
  } else if (target.name === 'factoryID') {
    setAttendanceDetail({
      ...attendanceDetail,
      [e.target.name]: value,
    });
  } 
 else {
    setAttendanceDetail({
      ...attendanceDetail,
      [e.target.name]: value
    });
  } 
  setAttendanceData([]);
  setPage(0);
}

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
        }
   
        body {
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: attendanceDetail.groupID,
              factoryID: attendanceDetail.factoryID,
              date: attendanceDetail.date,
              employeeTypeID: attendanceDetail.employeeTypeID
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                date: Yup.string().required('Select a date'),
              })
            }
            onSubmit={() => trackPromise(GetDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              size='small'
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={attendanceDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size='small'
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={attendanceDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="employeeTypeID">
                              Employee Type
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.employeeTypeID && errors.employeeTypeID)}
                              fullWidth
                              helperText={touched.employeeTypeID && errors.employeeTypeID}
                              name="employeeTypeID"
                              onBlur={handleBlur}
                              value={attendanceDetail.employeeTypeID}
                              variant="outlined"
                              size='small'
                              id="employeeTypeID"
                              onChange={(e) => handleChange(e)}
                            >
                              <MenuItem value={'0'}>--Select Employee Type--</MenuItem>
                              {generateDropDownMenu(employeeTypes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              size='small'
                              fullWidth
                              name="registrationNumber"
                              onChange={(e) => handleChange(e)}
                              value={attendanceDetail.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                            >
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="date">
                              Date *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.date && errors.date)}
                              fullWidth
                              helperText={touched.date && errors.date}
                              size='small'
                              name="date"
                              type="date"
                              onChange={(e) => handleChange(e)}
                              value={attendanceDetail.date}
                              variant="outlined"
                              id="date"
                            />
                          </Grid>
                          <Grid container justify="flex-end">
                            <Box pr={2}>
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                              >
                                Search
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </CardContent>
                      <br />
                      <br />
                      <Divider />
                      <Box minWidth={1050} style={{paddingRight:'10px', paddingLeft:'10px'}}>
                        {attendanceData.length > 0 ?
                          <TableContainer>
                            <Table aria-label="caption table">
                              <TableHead>
                                  <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold",fontSize:"12px"}}>Reg No</TableCell>
                                    <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold",fontSize:"12px"}}>Employee Code</TableCell>
                                    <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold",fontSize:"12px"}}>Employee Name</TableCell>
                                    <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold",fontSize:"12px"}}>Employee Type</TableCell>
                                    <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold",fontSize:"12px"}}>In Time</TableCell>
                                    <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold",fontSize:"12px"}}>Out Time</TableCell>
                                    <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold",fontSize:"12px"}}>OT Hours</TableCell>
                                    <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold",fontSize:"12px"}}>Regular Hours</TableCell>
                                    <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold",fontSize:"12px"}}>Total Hours</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                {attendanceData.slice(page * limit, page * limit + limit).map((data, index) => (
                                  <TableRow key={index} style={{ border: "2px solid black" }}>
                                  <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' ,fontSize:"12px"}} align="left">{data.registrationNumber}</TableCell>
                                  <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' ,fontSize:"12px"}} align="left">{data.employeeCode}</TableCell>
                                  <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' ,fontSize:"12px"}} align="left">{data.employeeName}</TableCell>
                                  <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' ,fontSize:"12px"}} align="left">{data.employeeTypeName}</TableCell>
                                  <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 ,fontSize:"12px"}}align="center">{data.inTime  ? handleDateTime(data.inTime) : "N/A"}</TableCell>
                                  <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 ,fontSize:"12px"}} align="center">{data.outTime ? handleDateTime(data.outTime) : <b style={{color: "red"}}>Pending...</b>}</TableCell>
                                  <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 ,fontSize:"12px"}} align="right">{data.otHours ? `${data.otHours}m` : "0m"}</TableCell>
                                   <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 ,fontSize:"12px"}} align="right">{calculateRegularHours(data.inTime, data.outTime, data.otHours)}</TableCell>
                                  <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 ,fontSize:"12px"}} align="center">{formatDecimalHours(data.totalHours)}</TableCell>
                                  </TableRow>
                                ))} 
                            </TableBody>
                            </Table>
                            <TablePagination
                              component="div"
                              count={attendanceData.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer> : null}
                      </Box>
                      {attendanceData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                          >
                            EXCEL
                          </Button>

                          <ReactToPrint
                            documentTitle={"Employee Attendance Details Report - " + selectedSearchValues.groupName + ' ' + selectedSearchValues.factoryName + ' ' + attendanceDetail.date }
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                            >
                              PDF
                            </Button>}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              attendanceData={attendanceData} 
                              searchData={selectedSearchValues}
                              attendanceDetail={attendanceDetail}
                              regularHours={calculateRegularHours}
                              formatDecimalHours={formatDecimalHours}
                              handleDateTime={handleDateTime}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  )
}